module.exports = __webpack_public_path__ + "media/images/restaurant/areas/hokkaido_m-a559863f48202cff928b8047474c7a0b.png";